export function formatDateString(
  inputDate: string | null | undefined
): string | null {
  if (!inputDate) {
    return null
  }
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/
  if (!dateRegex.test(inputDate)) {
    throw new Error(`Invalid date format: ${inputDate}. Expected yyyy-MM-dd.`)
  }
  const [year, month, day] = inputDate.split('-')
  const parsedYear = parseInt(year, 10)
  const parsedMonth = parseInt(month, 10)
  const parsedDay = parseInt(day, 10)
  if (isNaN(parsedYear) || isNaN(parsedMonth) || isNaN(parsedDay)) {
    throw new Error(`Invalid date values in: ${inputDate}.`)
  }
  const paddedMonth = parsedMonth.toString().padStart(2, '0')
  const paddedDay = parsedDay.toString().padStart(2, '0')
  return `${paddedDay}.${paddedMonth}.${parsedYear}`
}
